import { useConvexAuth } from "@convex-dev/auth/react";
import { useQuery } from "convex/react";
import { LoaderCircle } from "lucide-react";
import AuthScreen from "../features/auth/AuthScreen";
import AppShell from "./AppShell";
import Onboarding from "../features/onboarding/Onboarding";
import { api } from "../lib/convexApi";

export default function App() {
  const { isLoading, isAuthenticated } = useConvexAuth();
  const settings = useQuery(api.settings.get, isAuthenticated ? {} : "skip");
  if (isLoading) return <main className="loading-screen"><LoaderCircle className="spin" aria-hidden="true"/><span>Opening your operations desk…</span></main>;
  if (!isAuthenticated) return <AuthScreen />;
  if (settings === undefined) return <main className="loading-screen"><LoaderCircle className="spin" aria-hidden="true"/><span>Opening your private workspace…</span></main>;
  return !settings?.onboardingComplete ? <Onboarding initial={settings}/> : <AppShell />;
}
